
























import { Component, Prop, Vue } from 'vue-property-decorator';

import TopBar from '@/shared/components/TopBar.component.vue';
import Assets from '@/constants/assets';

@Component({
    components: {
        TopBar,
    },
})

export default class TopModal extends Vue {
  @Prop({ default: false } ) private modalTopOpened!: boolean;
  @Prop({ default: true }) private borderTop!: boolean;
  @Prop({ default: false }) private publicModal!: boolean;


  private assets = Assets;

  private emitModalClose() {
    this.$emit( 'close-modal' );
  }

}
